import { appPaths, type AppPath } from "../../app/appPaths.js";

interface SettingsSection {
  label: string;
  path: AppPath<`/settings/${string}`>;
}

/**
 * The settings sections, defined once so the left-nav menu and the breadcrumb
 * trail can't drift apart on labels or targets. Visibility rules live in
 * SettingsNavigationMenu (nav) and SettingsSectionGuard (routes).
 */
export const settingsSections = {
  profile: { label: "Profile", path: appPaths.settingsProfile },
  organization: { label: "Organization", path: appPaths.settingsOrganization },
  teammates: { label: "Teammates", path: appPaths.settingsTeammates },
  teammateGroups: {
    label: "Teammate groups",
    path: appPaths.settingsTeammateGroups,
  },
  signIn: { label: "Sign-in settings", path: appPaths.settingsSignIn },
  billing: { label: "Billing", path: appPaths.settingsBilling },
  forms: { label: "Pre-interview forms", path: appPaths.settingsForms },
  messageTemplates: {
    label: "Message templates",
    path: appPaths.settingsMessageTemplates,
  },
  integrations: {
    label: "Integrations",
    path: appPaths.settingsIntegrations,
  },
  dataExtraction: {
    label: "Data extraction",
    path: appPaths.settingsDataExtraction,
  },
  customFields: { label: "Custom fields", path: appPaths.settingsCustomFields },
  keywordTrackers: {
    label: "Keyword trackers",
    path: appPaths.settingsKeywordTrackers,
  },
  recording: { label: "Recording", path: appPaths.settingsRecording },
  playbooks: { label: "Playbooks", path: appPaths.settingsPlaybooks },
  knowledgeBases: {
    label: "Knowledge bases",
    path: appPaths.settingsKnowledgeBases,
  },
  signals: { label: "Signals", path: appPaths.settingsSignals },
  webhooks: { label: "Webhooks", path: appPaths.settingsWebhooks },
  developers: { label: "API keys", path: appPaths.settingsDevelopers },
} as const satisfies Record<string, SettingsSection>;
